// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubscriptionTerms_AcceptInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * SubscriptionTerms_AcceptInput — body for POST /subscriptions/terms/accept.
 *
 * THE SIGNATURE ARRIVES FROM THE CLIENT, so everything about it is validated
 * here and nothing about it is trusted. The hash is NOT accepted from the
 * caller: the server computes it over the decoded bytes it actually stored,
 * the same rule the document body follows.
 *
 * Refusals are named so the form can say which one happened:
 * 'assinatura_ausente', 'assinatura_formato_invalido',
 * 'assinatura_muito_grande', 'assinatura_insuficiente', 'metodo_invalido'.
 */
import { registerContract } from './validate'

export interface SubscriptionTerms_AcceptInput {
franquia_id: number
term_id: number
assinatura_png: string
assinatura_metodo?: string
assinatura_pontos?: number
assinatura_ms?: number
}

registerContract('SubscriptionTerms_AcceptInput', {
  franquia_id:       { type: 'number',  required: true },
  term_id:           { type: 'number',  required: true },
  assinatura_png:    { type: 'string',  required: true },
  assinatura_metodo: { type: 'string',  required: false },
  assinatura_pontos: { type: 'number',  required: false },
  assinatura_ms:     { type: 'number',  required: false },
})
